import { GetScenarioResultResponse } from "@mutiny-group/sbo-openapi-client";
import { useQuery } from "@tanstack/react-query";

import { QueryConfig } from "@/lib/react-query";
import { ScenarioBuilderClient } from "@/pages/scenario-builder/api/client/scenarioClient";
import { useScenarioBuilderClient } from "@/pages/scenario-builder/api/hooks/useScenarioBuilderClient";

const getScenarioResultsV2 = (scenarioBuilderClient: ScenarioBuilderClient, uuid: string) => {
  return scenarioBuilderClient.scenarios.getScenarioResults({
    scenarioUuid: uuid,
  });
};

type UseScenarioResultsV2Options = {
  uuid: string;
  breakdownResultsGeography?: boolean;
  config?: QueryConfig<any>;
};

const transformScenarioResult = (data: GetScenarioResultResponse) => {
  return {
    ...data,
    scenarioRevenues: data.marketingRevenues.map((revenue) => ({
      ...revenue,
      saleBrand: revenue.saleNode.brand,
      saleCategory: revenue.saleNode.category,
      saleProduct: revenue.saleNode.product,
      saleCustomer: revenue.saleNode.customer,
      saleDivision: revenue.saleNode.division,
      marketingSpendBrand: revenue.marketingSpendNode.brand,
      marketingSpendCategory: revenue.marketingSpendNode.category,
      marketingSpendProduct: revenue.marketingSpendNode.product,
      marketingSpendCustomer: revenue.marketingSpendNode.customer,
      marketingSpendDivision: revenue.marketingSpendNode.division,
    })),
    scenarioSpends: data.marketingSpends.map((spend) => ({
      ...spend,
      marketingSpendBrand: spend.marketingSpendNode.brand,
      marketingSpendCategory: spend.marketingSpendNode.category,
      marketingSpendProduct: spend.marketingSpendNode.product,
      marketingSpendCustomer: spend.marketingSpendNode.customer,
      marketingSpendDivision: spend.marketingSpendNode.division,
    })),
    // TODO: Add scenario constraints -> backend is missing it currently.
    scenarioConstraints: [],
  };
};

export const useScenarioResultsV2 = ({ uuid, config }: UseScenarioResultsV2Options) => {
  const scenarioBuilderClient = useScenarioBuilderClient();
  return useQuery({
    ...config,
    queryKey: ["scenario-results-v2", uuid, scenarioBuilderClient],
    queryFn: async () => await getScenarioResultsV2(scenarioBuilderClient, uuid),
    select: (data: GetScenarioResultResponse) => transformScenarioResult(data),
  });
};
